import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import Text from "components/layout/Text";
import { ICustomViewFilterForDisplay } from "store/views/tickets/helpers";

interface IProps {
  filtersForDisplay: ICustomViewFilterForDisplay[];
  lineHeight?: string;
  fontSize?: string;
  noMargin?: boolean;
}

const Row = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 9px;
  }

  &.no-margin {
    margin-bottom: 0px;
  }
`;

const CustomViewFilters: React.FC<IProps> = ({
  filtersForDisplay,
  lineHeight = "19px",
  noMargin = false,
  fontSize = "inherit",
}) => (
  <>
    {filtersForDisplay.map(({ title, label, invalid }, index) => (
      // @ts-expect-error TS(2322)
      <Row key={index} className={noMargin && "no-margin"}>
        <Text
          lineHeight={lineHeight}
          fontSize={fontSize}
          inline
          css={{ color: `var(${DesignToken.ContentBasicSecondary})` }}
        >
          {title}:&nbsp;
        </Text>
        <Text
          lineHeight={lineHeight}
          fontSize={fontSize}
          inline
          color={invalid ? "errorColor" : `var(${DesignToken.ContentBasicPrimary})`}
        >
          {label}
        </Text>
      </Row>
    ))}
  </>
);

export default CustomViewFilters;
